<template>
    <div>
        <el-popover
            v-if="tipMessage"
            trigger="hover"
            placement="top"
            :content="tipMessage"
        >
            <slot slot="reference"></slot>
        </el-popover>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    name: 'ConditionalPopover',
    props: {
        tipMessage: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>

</style>
